import { render, staticRenderFns } from "./nav-sub-item.vue?vue&type=template&id=0e0adffe&"
import script from "./nav-sub-item.vue?vue&type=script&lang=js&"
export * from "./nav-sub-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports